import { buildProps } from '@ll-plus/utils'

import Pagination from '../components/pagination.vue'

import type { ExtractPropTypes } from 'vue'

export const tablePaginationProps = buildProps({
  /**
   * @description 当前页数
   */
  current: {
    type: Number,
  },
  /**
   * @description 每页条数
   */
  pageSize: {
    type: Number,
  },
  /**
   * @description 数据总数
   */
  total: {
    type: Number,
  },
  /**
   * @description 用于显示数据总量和当前数据顺序
   */
  showTotal: {
    type: Function,
  },
  /**
   * @description 页码或 pageSize 改变的回调，参数是改变后的页码及每页条数
   */
  onChange: {
    type: Function, // 函数不能写默认值,写了就是必要要传
  },
  /**
   * @description 页码或 pageSize 改变的回调，参数是改变后的页码及每页条数
   */
  simple: {
    type: Boolean,
  },
  // 分页器尺寸
  size: {
    type: String,
    default: 'medium',
  },
  /**
   * @description 分页对齐方式，可选值：left、center、right
   */
  alignment: {
    type: String,
    default: 'right',
    validator: (val: string) => ['left', 'center', 'right'].includes(val),
  },
} as const)

// props
export type TablePaginationProps = ExtractPropTypes<typeof tablePaginationProps>

// instance
export type TablePaginationInstance = InstanceType<typeof Pagination>
